<div  class="contractes-content">
  <div class="mdl-grid mdl-grid--no-spacing">
    <h5 class="mdl-layout-title mdl-cell--12-col">
      {{::'DEFAULT_ADMINISTRADORS' | translate}}
    </h5>

    <div class="mdl-cell--12-col">
      <md-card>
        <md-card-content>
          <div class="mdl-grid ">
          <div class="mdl-cell--2-col "><div class="circle-ok"></div> {{::'USUARI_CONFIRMAT_TITOL' | translate}}</div>
          <div class="mdl-cell--2-col"><div class="circle-vermell"></div>  {{::'USUARI_NO_REGISTRAT_TITOL' | translate}}</div>
          <div class="mdl-cell--3-col "><div class="circle-groc"></div>  {{::'USUARI_NO_CONFIRMAT_TITOL' | translate}}</div>
        </div>
         <span ng-repeat="user in ctrl.entitat.administradors">
                     <a class="itec-link 
                     {{(user.deleted || user.fictici) ? 'color-vermell' : ''}}
                     {{(!user.deleted && !user.fictici && !user.confirmat) ? 'color-groc' : ''}} " ng-single-click="ctrl.viewuser({{user.id}});">
                       {{user.username}}</a>&nbsp; 
          </span>
        </md-card-content>
      </md-card>

        <h5 class="mdl-layout-title mdl-cell--12-col">
          <span>{{::'titol_enviar_admins' | translate}}</span>
        </h5>
        <md-card>
        <md-card-content>
          <div class="mdl-grid ">
          <div class="mdl-cell mdl-cell--12-col">
             <form>
              <itec-select
                 class="mdl-cell mdl-cell--12-col"
                 property-id="id"
                 property-label="name"
                 list="ctrl.listnotificar"
                 name="tipusnotificacions"
                 ng-model="ctrl.entitat.tipusnotificacions"
                 ng-disabled="false"
                 ng-change-function="ctrl.onEnviarAdminsChange()">
              </itec-select>
            </form>
          </div>
          </div>
        </md-card-content>
        </md-card>

    </div>

  </div>
</div>
